export default __webpack_public_path__ + "static/meet-john-hero-454a6bc2bc973bdc69c7bf6cbb23d90f.webp";